module.exports = __webpack_public_path__ + "img/spark_basket_01.3b0bb6f7.png";